import { visionLabApi } from '@/app/apiClient';
import type {
  Organization,
  OrganizationPage,
  Project,
  ProjectPage,
} from '@/features/organization-project-picker/types/organizationProjectPicker';
import type { ApiCallOptions } from '@/shared/api/client';

export async function fetchOrganizations(
  params: { q?: string; cursor?: string; limit?: number } = {},
  options: ApiCallOptions = {},
): Promise<OrganizationPage> {
  return visionLabApi.get<OrganizationPage>('/organizations', {
    ...options,
    searchParams: {
      q: params.q || undefined,
      cursor: params.cursor || undefined,
      limit: params.limit,
    },
  });
}

export async function fetchOrganization(
  organizationId: string,
  options: ApiCallOptions = {},
): Promise<Organization> {
  return visionLabApi.get<Organization>(
    `/organizations/${encodeURIComponent(organizationId)}`,
    options,
  );
}

export async function fetchOrganizationProjectsPage(
  organizationId: string,
  params: { cursor?: string; limit?: number } = {},
  options: ApiCallOptions = {},
): Promise<ProjectPage> {
  return visionLabApi.get<ProjectPage>(
    `/organizations/${encodeURIComponent(organizationId)}/projects`,
    {
      ...options,
      searchParams: {
        cursor: params.cursor || undefined,
        limit: params.limit,
      },
    },
  );
}

export async function fetchProject(
  projectId: string,
  options: ApiCallOptions = {},
): Promise<Project> {
  return visionLabApi.get<Project>(`/projects/${encodeURIComponent(projectId)}`, options);
}
